import { createContext, useContext, useState, useEffect, useCallback, useMemo } from 'react';
import translations from './translations';

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    // Get saved language or default to Italian
    const saved = localStorage.getItem('phisioletters_lang');
    return saved || 'it';
  });

  useEffect(() => {
    localStorage.setItem('phisioletters_lang', language);
  }, [language]);

  const t = useCallback((key) => {
    const keys = key.split('.');
    let value = translations[language];
    
    for (const k of keys) {
      if (value && value[k]) {
        value = value[k];
      } else {
        // Fallback to Italian
        value = translations['it'];
        for (const fallbackKey of keys) {
          if (value && value[fallbackKey]) {
            value = value[fallbackKey];
          } else {
            return key; // Return key if not found
          }
        }
        break;
      }
    }
    
    return value;
  }, [language]);

  const changeLanguage = useCallback((lang) => {
    if (['it', 'en', 'es'].includes(lang)) {
      setLanguage(lang);
    }
  }, []);

  const value = useMemo(() => ({ language, t, changeLanguage }), [language, t, changeLanguage]);

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export default LanguageContext;
